export default {
  country: ['India', 'Turkey', 'UAE'],
  city: [
    'New Delhi',
    'Chennai',
    'Gurgaon',
    'Istanbul',
    'Ankara',
    'Dubai',
    'Abudhabi',
    'Sharjah',
    'Manila',
    'Bangkok',
    'Kuala Lumpur',
    'Berlin',
    'Ahmedabad',
    'Bhubaneswar',
    'Lucknow',
    'Bangalore',
    'Faridabad',
    'Ghaziabad',
    'Kolkata',
    'Hyderabad',
    'Mumbai',
    'Noida',
    'Pune',
    'Singapore'
  ],
  departments: [
    'cardiology_and_cardiac_surgery',
    'cosmetic_and_plastic_surgery',
    'dental_treatment',
    'dermatology',
    'endocrinology',
    'ent_surgery',
    'gastroenterology',
    'general_surgery',
    'gynecology',
    'hair_treatment',
    'hematology',
    'hepatology',
    'ivf_and_infertility',
    'nephrology',
    'neurology_and_neurosurgery',
    'obesity_or_bariatric_surgery',
    'oncology_and_oncosurgery',
    'opthalmology',
    'orthopedics',
    'pediatric_cardiology',
    'pediatrics_and_pediatric_surgery',
    'pulmonology',
    'rheumatology',
    'spine_surgery',
    'transplant_surgery',
    'urology_treatment',
    'vascular_surgery'
  ],

  secondOpinionDepartments: [
    'cardiology_and_cardiac_surgery',
    'gynecology',
    'hematology',
    'hepatology',
    'neurology_and_neurosurgery',
    'oncology_and_oncosurgery',
    'orthopedics',
    'urology_treatment',
  ],

  treatments: [
    'liver_transplant',
    'thalassemia_treatment',
    'shoulder_replacement_surgery',
    'oral_cancer_surgical',
    'kidney_transplant',
    'pediatric_liver_transplant_surgery',
    'total_hip_replacement',
    'heart_bypass_surgery_cabg',
    'repair_of_shoulder_rotator_cuff',
    'ivf',
    'pet_scan',
    'bone_marrow_transplant',
    'knee_replacement_surgery',
    'spine_decompression_surgery',
    'cervical_cancer_treatment',
    'gallbladder_cancer_treatment',
    'heart_surgery',
    'heart_transplant',
    'pediatric_otoplasty',
    'neuro_rehabilitation',
    'gastric_banding_surgery',
    'gastric_bypass_surgery',
    'gastric_sleeve_surgery',
    'prostate_cancer_surgical',
    'cervical_spine_surgery',
    'artificial_spine_lumbar_disc_replacement',
    'ovarian_cancer_surgery',
    'elbow_replacement_surgery',
    'spinal_fusion_surgery',
    'spinal_endoscopic_surgery',
    'scoliosis_spine_surgery',
    'bilateral_hip_replacement_surgery',
    'revision_single_knee_replacement',
    'pituitary_tumor_treatment',
    'knock_knee_surgery',
    'removal_of_kidney_stones',
    'chemotherapy',
    'oculoplasty',
    'spine_tumour_surgery',
    'mitral_valve_replacement',
    'lumbar_laminectomy_for_spine',
    'partial_hip_replacement_surgery_unilateral_hip_replacement',
    'gynecomastia_treatment',
    'body_lift_surgery',
    'orbital_surgery',
    'ivf_1_cycle_own_egg_and_sperm_icsi_including_injections',
    'angiography',
    'kyphosis_hunchback_treatment',
    'single_bypass_and_valve_replacement',
    'comprehensive_myelopathy_spinal_cord_surgery',
    'minimally_invasive_spine_surgery',
    'coronary_angiogram',
    'wrist_joint_replacement_wrist_arthroplasty',
    'colon_cancer_treatment',
    'single_ventricle_defects_surgery',
    'crt_d_implant_cardiac_resynchronization_therapy',
    'blepharoplasty_eye_lid_surgery',
    'ppi_permanent_pacemaker_implant_double_chamber',
    'breast_cancer',
    'tapvc_total_anomalous_pulmonary_venous_connection_repair_arterial_switch',
    'knee_replacement_bilateral',
    'stomach_cancer_treatment',
    'aicd',
    'shoulder_arthroscopy',
    'hair_transplantation',
    'aortic_valve_replacement',
    'tummy_tuck',
    'pectoral_implant_surgery',
    '24_hour_holter_monitoring',
    '64_slice_ct_angiography',
    'abdominal_aortic_aneurysm_treatment',
    'abdominoperineal_resection',
    'abdominoplasty',
    'abscess_intra_abdominal_treatment',
    'abscess_subphrenic_treatment',
    'abscess_drainage',
    'abscess_pelvic_treatment',
    'acetabular_fixation',
    'acl_reconstruction',
    'acoustic_neuroma',
    'acromioclavicular_joint_repair',
    'acute_lymphocytic_leukemia_all_in_adults',
    'adenocarcinoma_glandular_cancer_treatment',
    'adenoidectomy',
    'adenotonsillectomy',
    'adhesion_surgery',
    'adolescent_idiopathic_scoliosis_treatment',
    'adrenal_cancer_treatment',
    'almond_eye',
    'alzheimer_s_disease_treatment',
    'ambiguous_genitalia_surgery',
    'ambulatory_bp_monitoring_abpm',
    'amputation_above_knee',
    'amputation_below_knee',
    'anal_cancer_treatment',
    'anal_sphincteroplasty',
    'andrology',
    'angioplasty_and_stent_placement',
    'ankle_arthroscopy',
    'anterior_cervical_corpectomy_spine_surgery',
    'anterior_cervical_discectomy',
    'anterior_cervical_discectomy_and_fusion_acdf',
    'anterior_posterior_repair_colporrhaphy',
    'anti_reflux_procedures',
    'anti_wrinkle_treatment',
    'anti_wrinkle_treatment_by_laser',
    'aortic_aneurysm_repair',
    'aortic_dissection_repair_surgery',
    'aortic_stent_grafting',
    'aortofemoral_bypass_surgery',
    'apicoectomy',
    'aplastic_anemia',
    'appendectomy',
    'appendicitis_treatment',
    'arm_lift',
    'arrhythmia_treatment_with_ablation_and_pacemakers',
    'arterial_aneurysms',
    'arterial_switch_operation',
    'arteriovenous_malformations',
    'arthritis',
    'arthrodesis',
    'arthrolysis',
    'arthroscopic_debridement_of_calcium_deposits',
    'arthroscopic_menisectomy',
    'arthrotomy',
    'arytenoidectomy',
    'asd_atrial_septal_defect_closure',
    'astigmatism_treatment',
    'atrial_fibrillation_surgery',
    'augmentation_cystoplasty',
    'augmentation_mastopexy',
    'autologous_chondrocyte_implantation_aci',
    'av_canal_repair',
    'back_stretching',
    'balance_disorders_treatment',
    'balloon_angioplasty',
    'balloon_mitral_valvotomy',
    'balloon_septostomy',
    'balloon_sinuplasty',
    'balloon_valvuloplasty_aortic',
    'bariatric_surgery_for_weight_loss',
    'bartholin_abscess_excision_and_drainage',
    'basal_cell_and_squamous_cell_carcinoma',
    'beard_transplant',
    'bell_s_palsy_treatment',
    'bentall_procedure',
    'bichat_fat_pad_removal',
    'bichectomy',
    'bile_duct_cancer_treatment',
    'biliary_drainage_and_stenting_surgery',
    'biventricular_pacing',
    'bladder_cancer_treatment',
    'bladder_exstrophy_and_epispadias_treatment',
    'bladder_instillation',
    'bladder_slings_tot_and_tvt_slings',
    'blade_free_lasik',
    'blalock_taussig_bt_shunt',
    'blastocyst_culture_and_transfer',
    'blepharoplasty_just_below_or_upper',
    'blepharoplasty_just_below_or_upper_local',
    'blepharoplasty_both_caps_together',
    'blepharoplasty_both_caps_together_local',
    'blocked_fallopian_tube_treatment',
    'blood_clot_brain_surgery',
    'body_contouring',
    'bone_cancer_treatment',
    'bone_marrow_cancer',
    'botox',
    'boutonniere_deformity_treatment',
    'bowel_obstruction_treatment',
    'brain_avm_embolization_with_onyx',
    'brain_haemorrhage_treatment',
    'brain_tumor_surgery',
    'branchial_cleft_cyst_surgery',
    'brazilian_butt_lift',
    'breast_augmentation',
    'breast_biopsy',
    'breast_cancer_surgical',
    'breast_enlargement_mammoplasty',
    'breast_implant_revision_surgery',
    'breast_implants',
    'breast_lift_surgery',
    'breast_reconstruction_with_implant',
    'breast_reconstruction_with_muscle_skin_flap',
    'breast_reduction',
    'breast_reduction_mammoplasty',
    'bronchoscopy',
    'brow_lift_surgery',
    'browplasty_forehead_lift',
    'caldwell_luc_antrostomy',
    'calf_implant',
    'canalplasty',
    'cancer_treatment',
    'carcinoid_tumors_treatment',
    'carcinoma_of_unknown_primary_cup_treatment',
    'cardiac_ablation',
    'cardiac_catheterization',
    'cardiac_tumour_treatment',
    'carotid_artery_stenosis',
    'carotid_endarterectomy',
    'carpal_tunnel_release_ctr_open_or_endoscopic',
    'castleman_disease_treatment',
    'cataract_implant_surgery',
    'cataract_surgery',
    'celiac_disease_treatment',
    'cemented_total_hip_replacement',
    'cementless_total_hip_replacement_thr_surgery',
    'ceramic_braces',
    'cerebral_angiogram',
    'cerebral_angioplasty',
    'cerebral_or_brain_aneurysm_treatment',
    'cervical_corpectomy',
    'cervical_spondylosis',
    'cesarean_section',
    'cheek_augmentation',
    'chemical_peel',
    'chin_implant_surgery',
    'cholestaeoma_treatment',
    'chronic_cerebro_spinal_venous_insufficiency_treatment',
    'chronic_intestinal_pseudo_obstruction_cip_treatment',
    'chronic_kidney_disease',
    'circumcision',
    'cleft_lip_surgery',
    'cleft_palate_surgery',
    'cloacal_malformation_surgery',
    'closed_reduction_for_fracture',
    'coarctation_of_the_aorta_co_a_surgery',
    'coblation_tonsillectomy',
    'cochlear_implantation',
    'cochlear_implantation_bilateral',
    'colposcopy',
    'completion_thyroidectomy',
    'congenital_heart_disorder_chd',
    'congenital_limb_defects_surgery',
    'congenital_pseudarthrosis_of_the_tibia_cpt_surgery',
    'congenital_spine_cord_malformations_treatment',
    'congestive_heart_failure_chf_treatment',
    'conservative_management',
    'continuous_ambulatory_peritoneal_dialysis_capd',
    'corneal_transplantation_eye_transplant',
    'coronary_angioplasty',
    'coronary_artery_surgery',
    'corpus_callosotomy',
    'corrective_osteotomy_and_fixation_and_bone_graft',
    'corrective_osteotomy_fixation_and_ligament_reconstruction_surgery',
    'craniofacial_reconstruction_surgery',
    'cranioplasty',
    'craniotomy_surgery',
    'crohn_s_disease_treatment',
    'crt_d_mri_compatible',
    'crt_d_mri_non_compatible',
    'crt_p',
    'cryolipolysis_non_surgical_fat_reduction',
    'cryptorchidism_undescended_testicle_surgery',
    'cyber_knife_treatment',
    'cyclic_vomiting_syndrome_treatment',
    'cystectomy',
    'cystoscopy',
    'd_2_gastrectomy',
    'debridement_of_wound_burn_or_infection',
    'deep_anterior_lamellar_keratoplasty_dalk',
    'deep_brain_stimulation',
    'deep_brain_stimulation_non_rechargeable',
    'dental_anti_microbial_therapy',
    'dental_bone_grafting',
    'dental_crowns_dental_cap',
    'dental_implants',
    'dental_inlays_and_onlays',
    'dental_sealants_pit_and_fissure_sealant',
    'dentures',
    'device_closure_asd_vsd',
    'diabetic_retinopathy_treatment',
    'diagnostic_laparoscopy',
    'disc_herniation',
    'double_inlet_left_ventricle_dilv_treatment',
    'double_outlet_right_ventricle_dorv_surgery',
    'drug_pump_implantation_for_chronic_pain_management',
    'duodenal_switch',
    'ear_foreign_body_removal_procedure',
    'ear_shape_correction_surgery',
    'early_onset_scoliosis_surgery',
    'ecg_treadmill_test_tmt',
    'echocardiography_with_color_doppler',
    'ecmo_support',
    'elbow_arthroscopy',
    'electrical_cortical_stimulation',
    'endometrial_ablation',
    'endometrial_cancer_treatment',
    'endometriosis_surgery',
    'endoscopic_adenoidectomy',
    'endoscopic_decompression',
    'endoscopic_face_lifting',
    'endoscopic_forehead_lift',
    'endoscopic_septoplasty',
    'endoscopic_sinus_surgery',
    'endoscopic_turbinectomy',
    'endoscopy',
    'endovascular_coiling',
    'epilepsy_treatment',
    'eps_electrophysiological',
    'erectile_dysfunction_treatment',
    'esophagus_cancer_treatment',
    'ethmoidectomy',
    'ewing_family_of_tumors_treatment',
    'excision_of_ear_tumor',
    'excision_of_preauricular_sinus',
    'extracapsular_cataract_extraction',
    'eye_cancer_treatment',
    'facelift',
    'facial_implants',
    'facial_nerve_decompression',
    'facial_trauma_surgery',
    'failure_to_thrive_ftt_treatment',
    'fallopian_tube_cancer',
    'fat_injection_breast',
    'fat_injection_butt',
    'fat_injection_face',
    'fat_injection_procedure',
    'fat_injection_for_repair_of_soft_tissue_defect_large_area',
    'fat_injection_for_repair_of_soft_tissue_defect_middle_area',
    'fat_injection_for_repair_of_soft_tissue_defect_small_area',
    'fat_transfer_and_liposculpture',
    'female_sterilization_tubectomy',
    'femoro_femoral_bypass',
    'femoroacetabular_impingement_fai_surgery',
    'fertility_surgeries',
    'fess_functional_endoscopic_sinus_surgery',
    'fetal_echocardiogram',
    'fibroid_removal_myomectomy',
    'fibroid_removal_surgery',
    'fillers_under_eyes',
    'flap_eared_correction_general_anesthesia',
    'flap_eared_correction_local_anesthesia',
    'fluoride_treatment',
    'fontan_conversion_surgery',
    'foot_and_ankle_deformity_correction',
    'frontoethmoidectomy',
    'frozen_embryo_transfer_fet',
    'fulguration_of_posterior_uretheral_valve',
    'gamma_knife_for_avm_or_brain_tumor',
    'ganglion_cyst_excision',
    'gastroesophageal_reflux_disease_gerd_treatment',
    'gastrointestinal_stromal_tumor_gist_treatment',
    'gender_affirmation_surgery',
    'genitourinary_cancer_treatment',
    'gestational_trophoblastic_disease_gtd_treatment',
    'gift_and_zift_procedure',
    'glaucoma_treatment',
    'glenn_procedure',
    'gliomas_treatment',
    'gonioplasty_iridoplasty',
    'gum_lifting_gingivectomy',
    'gynecologic_reconstructive_surgery',
    'haemorrhoids_treatment',
    'hair_transplant_fue',
    'hair_transplation_dhi',
    'hairy_cell_leukemia_hcl',
    'haplogenic_bone_marrow_transplant',
    'health_checkup',
    'hearing_loss_deafness_treatment',
    'heart_bypass_minimally_invasive_cabg',
    'heart_double_valve_replacement',
    'heart_implants',
    'hemiglossectomy',
    'hemispherectomy',
    'hemorrhoidectomy',
    'hepatitis_b_treatment',
    'hepatitis_c_treatment',
    'high_cervical_stimulation',
    'high_flex_knee_replacement',
    'high_tibial_osteotomy',
    'hip_arthroscopy',
    'hip_augumentation',
    'hip_reconstruction_surgery',
    'hipec',
    'hirsutism_treatment',
    'hiv_human_immunodeficiency_virus_treatment',
    'hodgkin_disease_treatment',
    'hydrocele_surgery',
    'hydrocephalus_treatment',
    'hydronephrosis_treatment',
    'hymenoplasty',
    'hypernasal_speech_treatment',
    'hyperopia_farsightedness_treatment',
    'hyperprolactinemia_treatment',
    'hypopharyngoscopy',
    'hypoplastic_left_heart_syndrome_hlhs_treatment',
    'hypospadias_repair_surgery',
    'hysterectomy',
    'hysteroscopy',
    'icd_implantation',
    'icl_surgery',
    'image_guided_endoscopic_nasal_and_sinus_surgery',
    'immunotherapy',
    'impacted_tooth_extraction',
    'implant_supported_denture',
    'imrt',
    'inguinal_hernia_repair_surgery',
    'injectable_filler',
    'intacs_corneal_implants',
    'internal_fixation_of_fractures',
    'interrupted_aortic_arch_surgery',
    'intracytoplasmic_sperm_injection_procedure_icsi',
    'intraocular_implants_io_ls',
    'invasive_lobular_carcinoma',
    'invisalign_aligners',
    'irregular_periods_treatment_irregular_menstrual_cycle',
    'irritable_bowel_syndrome_ibs_treatment',
    'iud_insertion_intrauterine_device_insertion',
    'iui_intrauterine_insemination',
    'ivc_filter_insertion',
    'ivf_with_donor_eggs',
    'ivf_2_cycle_own_egg_and_sperm',
    'ivf_1_cycle_own_egg_and_sperm_imsi_including_injections',
    'jowl_liposuction_general',
    'jowl_liposuction_local',
    'kaposi_sarcoma_treatment',
    'kidney_cancer_treatment',
    'knee_arthroscopy',
    'knee_meniscectomy',
    'labiaplasty_labia_rejuvenation',
    'labyrinthectomy',
    'laparoscopic_biliopancreatic_diversion',
    'laparoscopic_hysterectomy',
    'laparoscopic_myomectomy',
    'laparoscopic_supracervical_hysterectomy',
    'laryngeal_and_hypopharyngeal_cancer_treatment',
    'laryngeal_stenosis_treatment',
    'laryngeal_web_excision',
    'laryngectomy',
    'laser_and_intense_pulsed_light_therapies',
    'laser_assisted_hatching_lah_procedure',
    'laser_gum_depigmentation_gum_bleaching',
    'laser_hair_removal',
    'laser_iridotomy',
    'laser_peripheral_iridotomy',
    'laser_skin_resurfacing',
    'laser_teeth_whitening',
    'laser_thread_vein_removal',
    'lasik_procedure',
    'lateral_epicondyle_release_tennis_elbow',
    'lateral_retinacular_release_surgery',
    'lateral_tarsoraphy_local_single_eye',
    'leep_loop_electrosurgical_excision_procedure',
    'legg_calve_perthes_disease_lcpd_treatment',
    'lesionectomy',
    'leukemia_treatment',
    'leukoplakia_excision_surgery',
    'limb_lengthening',
    'lingual_braces',
    'lip_augmentation',
    'liposuction_2_3_sides',
    'liposuction_3_5_sides',
    'liposuction_surgery',
    'lithotripsy',
    'lithotripsy_stone_size_lt_1_cm',
    'liver_cancer',
    'liver_cirrhosis_treatment',
    'liver_resection',
    'lobectomy',
    'local_skin_flap_small',
    'lower_body_lift_surgery',
    'lower_femoral_osteotomy',
    'lung_cancer_treatment',
    'lung_carcinoid_tumor_treatment',
    'lvad',
    'male_factor_infertility',
    'malignant_mesothelioma_treatment',
    'mastoidectomy',
    'maxillectomy',
    'medullary_carcinoma',
    'melasma_treatment',
    'meningioma',
    'meniscal_repair',
    'metal_braces',
    'metastatic_tumors_treatment',
    'microdebrider_turbinectomy',
    'microdermabrasion',
    'microsurgical_repair_of_encephalocele',
    'microsurgical_tumor_removal',
    'microtia_surgery',
    'microvascular_decompression_mvd',
    'middle_ear_infection_otitis_media_treatment',
    'middle_face_lift',
    'mini_abdominoplasty_e',
    'mini_arm_lift',
    'minimally_invasive_hip_resurfacing',
    'minimally_invasive_knee_replacement_surgery',
    'mls_microlaryngeal_surgery',
    'modified_radical_mastectomy',
    'mole_removal',
    'mommy_makeover',
    'mon_pubis_liposuction_pubic_fat_liposuction',
    'monsplasty_pubic_lift',
    'multicystic_dysplastic_kidney_mcdk_treatment',
    'multiple_sclerosis_treatment',
    'multiple_subpial_transections_mst',
    'myocardial_perfusion_imaging_mpi_test',
    'myomectomy',
    'myopia_nearsightedness_treatment',
    'myringoplasty',
    'myringotomy',
    'narcolepsy_treatment',
    'nasal_cavity_and_paranasal_sinus_cancer_treatment',
    'nasal_endoscopy',
    'nasopharyngeal_cancer_treatment',
    'nasopharyngoscopy',
    'neck_dissection_surgery',
    'neck_lift',
    'nephrectomy',
    'nephropathy_treatment',
    'neurolysis_procedure',
    'neurosurgery',
    'nipple_correction_surgery',
    'nissen_fundoplication',
    'non_hodgkin_lymphoma_nhl_treatment',
    'non_neurogenic_voiding_dysfunction_treatment',
    'non_small_cell_lung_cancer_nsclc_treatment',
    'non_surgical_skin_tightening',
    'nosebleeds_epistaxis_treatment',
    'oocyte_cryopreservation_egg_freezing',
    'oophorectomy',
    'open_reduction_of_fracture',
    'oral_and_maxillofacial_surgery',
    'orbital_exenteration_surgery',
    'orchidopexy',
    'ossiculoplasty_ear_surgery',
    'osteochondral_autografting_mosaicplasty_surgery',
    'osteosarcoma_os_treatment',
    'osteotomy',
    'otoplasty',
    'ovarian_biopsy',
    'ovarian_cyst_removal',
    'ovarian_drilling_multiperforation',
    'ovarian_germ_cell_tumor',
    'ovarian_laparotomy',
    'ovarian_primary_peritoneal_cancer',
    'ovarian_sex_cord_stromal_tumor',
    'ovarian_tissue_freezing',
    'ovary_simulation',
    'ovulation_induction_procedure',
    'paediatric_aneurysm',
    'paediatrics_head_and_spine_trauma_treatment',
    'paget_s_disease',
    'palmar_fasciectomy',
    'pancreatic_cancer',
    'papillary_thyroid_cancer_treatment',
    'parathyroidectomy',
    'parkinson_s_disease',
    'parotidectomy',
    'partial_colectomy',
    'patello_femoral_replacement',
    'pda_device_closure',
    'pda_ligation',
    'pediatric_bedwetting_nocturnal_enuresis_treatment',
    'pediatric_cardiomyopathy_treatment',
    'pediatric_hip_dysplasia_surgery',
    'pediatric_inguinal_hernia_repair',
    'pediatric_myelodysplastic_syndrome_mds_treatment',
    'pelvic_reconstructive_surgery',
    'penile_cancer_treatment',
    'penile_implantation_single',
    'penile_lengthening_surgery',
    'peptic_ulcer_treatment',
    'percutaneous_balloon_compression_pbc',
    'percutaneous_steriotactic_treatment_psr',
    'perimenopause_treatment',
    'peripheral_angiogram',
    'peripheral_angioplasty',
    'peripheral_artery_disease_pad_treatment',
    'peritoneal_oocyte_and_sperm_transfer_prost',
    'pessary_insertion',
    'phacoemulsification',
    'pharyngectomy',
    'phimosis_and_paraphimosis_treatment',
    'phonosurgery',
    'photorefractive_keratectomy',
    'pineal_region_tumors_treatment',
    'placement_tissue_expanders',
    'plaque_brachytherapy',
    'pollicization_surgery',
    'polycystic_kidney_disease',
    'polycystic_ovary_syndrome_pcos_treatment',
    'polypectomy',
    'pop_pelvic_organ_prolapse_treatment',
    'porcelain_veneers',
    'posterior_cruciate_ligament_pcl_reconstruction',
    'ppi_permanent_pacemaker_implant_single_chamber',
    'preauricular_skin_tag_removal',
    'preimplantation_genetic_diagnosis_pgd',
    'prolapsed_disc',
    'prosthetic_eye',
    'prosthetic_implants',
    'ptca_percutaneous_transluminal',
    'pte_pulmonary_thromboendarterectomy',
    'pterygium_removal_surgery',
    'ptmc_percutaneous_transvenous_mitral_commissurotomy',
    'pulmonary_atresia_surgery',
    'pulmonary_fibrosis_treatment',
    'pulpotomy',
    'pvp_laser_prostatectomy',
    'pyeloplasty',
    'radical_nephrectomy',
    'radiofrequency_ablation',
    'radiofrequency_rhizotomy_neurotomy',
    'radiotherapy',
    'recurrent_miscarriage_treatment',
    'redo_cabg',
    'renal_angiogram',
    'renal_vein_thrombosis_treatment',
    'repair_of_choanal_atresia',
    'repair_of_digital_nerves',
    'restless_leg_syndrome_treatment',
    'retinal_detachment_surgery',
    'retinoblastoma_rb_treatment',
    'revision_acl_reconstruction_surgery',
    'revision_hip_replacement',
    'rhabdomyosarcoma_rms_treatment',
    'rhinoplasty',
    'rhinoplasty_primary',
    'rhinoplasty_revision',
    'rhinoplasty_tip',
    'robotic_partial_nephrectomy',
    'robotic_radical_nephrectomy',
    'root_canal_treatment',
    'ross_procedure',
    'rotational_atherectomy',
    'sacral_neuromodulation',
    'sacrectomy',
    'sacrocolpopexy',
    'salivary_gland_stone_removal',
    'salpingectomy',
    'salpingo_oopherectomy',
    'scaling_and_root_planing',
    'scalp_micropigmentation',
    'scar_removal_treatment',
    'scar_revision_longer_10_cm',
    'scar_revision_middle_between_5_10_cm',
    'scar_revision_smaller_5_cm',
    'schwannomas',
    'sclerotherapy_spider_vein_treatment',
    'sensory_ataxia_treatment',
    'septic_arthritis_treatment',
    'septorhinoplasty',
    'shoulder_labral_tears_surgery',
    'sickle_cell_anemia',
    'silicone_buttocks',
    'sinus_lift_surgery_sinus_augmentation',
    'sinusitis_sinus_infection_treatment',
    'skin_cancer',
    'skin_cancer_melanoma',
    'skin_grafting',
    'skin_lymphoma_treatment',
    'skull_base_surgery',
    'slip_disc',
    'slipped_capital_femoral_epiphysis_scfe_treatment',
    'small_incision_cataract_surgery',
    'small_intestine_cancer_treatment',
    'small_cell_carcinoma_treatment',
    'sns_sacral_nerve_stimulation',
    'soft_tissue_sarcoma_treatment',
    'solitary_kidney_treatment',
    'somnoplasty_snoring_surgery_turbinate_reduction_surgery',
    'spasticity_treatment',
    'spina_bifida_treatment',
    'spinal_cord_stimulation_for_pain',
    'spinal_dysraphism_treatment',
    'spinal_instrumentation',
    'spinal_stenosis',
    'spine_detethering_surgery',
    'spleen_removal_splenectomy',
    'split_earlobe_repair_surgery',
    'spondylitis',
    'spondylolisthesis_treatment',
    'sports_related_injuries',
    'squint_surgery',
    'stapedectomy_surgery',
    'stapled_haemorrhoidectomy_piles',
    'stereotactic_radio_surgery',
    'strabismus',
    'strabismus_surgery_eye_muscle_surgery',
    'stroke_treatment',
    'syndactyly_webbing_treatment',
    'synovectomy_of_hand',
    'tattoo_removal_by_laser',
    'tavi',
    'teeth_whitening',
    'temporal_lobectomy',
    'tendon_repair_surgery_flexor_extensor',
    'tendon_transfer',
    'tesa_pesa',
    'testicular_cancer_treatment',
    'testicular_implant',
    'testicular_torsion_surgery',
    'tetralogy_of_fallot_repair',
    'thallium_test_nuclear_stress_test',
    'thecoperitonial_shunt',
    'therapeutic_donor_insemination_tdi',
    'thigh_lift_surgery',
    'thigh_stretching',
    'thoracic_aortic_aneurysm_treatment',
    'thumb_arthroplasty',
    'thymoma_and_thymic_carcinoma_treatment',
    'thyroid_cancer_treatment',
    'thyroidectomy_surgery',
    'thyroplasty',
    'tibial_tubercle_transfer_for_patellofemoral_arthritis',
    'tip_plasty',
    'tlif_surgery',
    'tongue_tie_ankyloglossia_surgery',
    'tonsillectomy_surgery',
    'tooth_bridge',
    'tooth_colored_filling_white_fillings',
    'tooth_reshaping_and_dental_contouring',
    'total_anomalous_pulmonary_venous_return_tapvr_treatment',
    'trabeculectomy',
    'tracheostomy',
    'transarterial_radioembolization_tare',
    'transesophageal_echocardiography_tee',
    'transposition_of_the_great_arteries_tga_surgery',
    'transvaginal_oocyte_retrieval_tvor_oocyte_retrieval',
    'traumatic_injuries_to_the_head_and_neck',
    'trigger_point_injection_tpi',
    'triple_arthrodesis_and_internal_fixation',
    'truncus_arteriosus_treatment',
    'truncus_arterious_repair',
    'tubal_embryo_transfer_tet_procedure',
    'turbinoplasty',
    'turp',
    'tympanoplasty_eardrum_repair',
    'tympanostomy_tube_insertion',
    'ureter_re_implantation',
    'ureterocele_treatment',
    'urethral_bulking_injections',
    'urethral_stricture_surgery',
    'urethral_valves',
    'urethroplasty',
    'urinary_tract_infection_uti_treatment',
    'urodynamic_testing',
    'ursl',
    'uterine_fibroid_embolization_ufe',
    'uvulopalatopharyngoplasty_uppp',
    'vaginal_cancer_treatment',
    'vaginoplasty_vaginal_tightening',
    'vagus_nerve_stimulation',
    'valve_replacement',
    'varicocele_scrotum_varicose_veins_treatment',
    'varicose_veins_treatment',
    'vascular_lesion_surgery',
    'vasectomy',
    'vasectomy_reversal',
    'ventricular_septal_defect_vsd_treatment',
    'ventriculostomy',
    'vertebroplasty_and_kyphoplasty',
    'vestibulectomy',
    'vitrectomy',
    'vitreoretinal_surgery',
    'vns_implantation',
    'vp_shunting',
    'vsd_closure_adult_surgery',
    'vulvar_cancer_treatment',
    'wavefront_laser_eye_surgery',
    'whipple_surgery',
    'wilms_tumor_nephroblastoma',
    'yag_laser_capsulotomy',
    'z_plasty_multiple',
    'zirconia_tooth_crown'
  ]
};
